<template>
    <div id="modal_component" class="modal-component" v-if="modal">
        <div class="modal-area">
            <div class="modal-overlay">
                <div class="modal-overlay-inside">
                    <div class="modal-outer">
                        <div class="modal-close" @click="hideModal()"></div>
                        <div class="modal-inner">
                            <div class="image-container">
                                <img :src="source">
                            </div>
                            <div class="form-actions">
                                <div class="button--cancel"
                                     @click="hideModal()">Close</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['source'],
        computed: {
            modal () {
                return this.$store.getters.modals.image.visible
            }
        },
        methods: {
            hideModal () {
                this.$store.commit('modals', {
                    modal: 'image',
                    data: {
                        visible: false,
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal-outer{
        padding: 45px 30px 30px;
    }

    .form-actions{
        margin-top: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/modals/ImageModal.vue